import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

var _class, _descriptor;

/**
 * Servizio Modal Stack
 * Detiene lo stack dei modali (`modalComponents`) e il descrittore del modale
 * attivo (`modalComponent` = ultimo dello stack).
 * Estratto dal god-controller application (maintainability 4.2, gruppo H),
 * comportamento invariato; il controller mantiene una façade getter/setter.
 *
 * NOTE reattività: tutte le mutazioni esterne avvengono per copia+riassegnazione
 * (`set(applicationController, 'modalComponents', newArray)`), mai in-place, quindi
 * la façade getter/setter sul controller preserva la reattività identica a prima.
 */
let ModalStackService = (_class = class ModalStackService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modalComponents", _descriptor, this);
  }
  get modalComponent() {
    if (this.modalComponents && this.modalComponents.length > 0) {
      return this.modalComponents[this.modalComponents.length - 1];
    } else {
      return null;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "modalComponents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _class);

export { ModalStackService as default };
//# sourceMappingURL=modal-stack.js.map
